import { render, staticRenderFns } from "./TimeGuruVip2.vue?vue&type=template&id=60a42659&scoped=true"
import script from "./TimeGuruVip2.vue?vue&type=script&lang=js"
export * from "./TimeGuruVip2.vue?vue&type=script&lang=js"
import style0 from "./TimeGuruVip2.vue?vue&type=style&index=0&id=60a42659&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a42659",
  null
  
)

export default component.exports